"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcRentalFormFixedAssets = class UcRentalFormFixedAssets extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    editable;
    onEditable(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("editable");
    }
    rentalId;
    onRental_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("rentalId");
    }
    items;
    async $$load_items() {
        return this.$fn.fetch('list_rental_asset', { parameters: { rental_id: this.rentalId } });
    }
    ux;
    b_7315092382398562_columns;
    async $$load_b_7315092382398562_columns() {
        return [{
                name: "locked",
                type: "lock",
            },
            {
                name: "inactive",
                header: this.$fn.gettext("Inactive"),
                width: "30px",
                textAlign: "center",
                formatter: {
                    name: "checkbox",
                },
                editor: {
                    name: "checkbox",
                },
            },
            {
                name: "valid_from",
                type: "date",
                header: this.$fn.gettext("Valid From"),
                width: "120px",
            },
            {
                name: "valid_to",
                type: "date",
                header: this.$fn.gettext("Valid To"),
                width: "120px",
            },
            {
                name: "asset",
                type: "select2",
                header: this.$fn.gettext("Fixed Asset"),
                width: "250px",
                required: true,
                path: "name",
                bindObject: true,
                textField: "name",
                options: this.$fn.searchDataSource('suggest_fixed_asset', { t: 'fixed_asset' }),
            },
            {
                name: "notes",
                header: this.$fn.gettext("Notes"),
                width: "320px",
            },
        ];
    }
    dataMembers = ['items', 'ux', 'b_7315092382398562_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                items: null,
                ux: {
                    initialLoadSpinner: true,
                },
                b_7315092382398562_columns: null,
            },
        };
    }
    async act_7315092382398562_script_9552_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('rental_asset').upsert({
            ...$event.data.row,
            asset_id: $event.data.row.asset.id
        }));
    }
    async act_7315092382398562_script_9552_getActionArgs($event) {
        return {
            value: () => this.act_7315092382398562_script_9552_getActionArgs_value($event),
        };
    }
    async evh_7315092382398562_save(event, scope) {
        return await this.actions.evh_7315092382398562_save.executeFromDOM(this, event, scope);
    }
    async act_7315092382398562_script_9554_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('rental_asset').delete($event.data.row));
    }
    async act_7315092382398562_script_9554_getActionArgs($event) {
        return {
            value: () => this.act_7315092382398562_script_9554_getActionArgs_value($event),
        };
    }
    async evh_7315092382398562_delete(event, scope) {
        return await this.actions.evh_7315092382398562_delete.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_script_9552 = new core_1.actions.ScriptAction({
            actionArgs: this.act_7315092382398562_script_9552_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_save_9551 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_script_9552,
            event: "save",
            displayName: "script",
        });
        const evh_7315092382398562_save = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_save_9551],
        });
        const act_7315092382398562_script_9554 = new core_1.actions.ScriptAction({
            actionArgs: this.act_7315092382398562_script_9554_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_delete_9553 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_script_9554,
            event: "delete",
            displayName: "script",
        });
        const evh_7315092382398562_delete = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_delete_9553],
        });
        return {
            act_7315092382398562_script_9552,
            evh_7315092382398562_save_9551,
            evh_7315092382398562_save,
            act_7315092382398562_script_9554,
            evh_7315092382398562_delete_9553,
            evh_7315092382398562_delete,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
        default: true,
    }),
    __metadata("design:type", Boolean)
], UcRentalFormFixedAssets.prototype, "editable", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('editable'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcRentalFormFixedAssets.prototype, "onEditable", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], UcRentalFormFixedAssets.prototype, "rentalId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('rentalId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcRentalFormFixedAssets.prototype, "onRental_id", null);
UcRentalFormFixedAssets = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcRentalFormFixedAssets);
exports.default = UcRentalFormFixedAssets;
vue_property_decorator_1.Vue.component("UcRentalFormFixedAssets", UcRentalFormFixedAssets);
